const AddressesConfig = {
    ciamCustomerId: "edda5da6d0c648b18a60a5ab9c6197bb",
    countryCode: "IE",
    receivers: [
        {
            addressLine1: "Apartment 1",
            addressLine2: "4 Leeson Park Street Lower",
            addressLine3: "Dublin 2",
            addressLine4: "",
            addressLine5: "",
            addressLine6: "",
            addressLine7: "",
            addressLine8: "",
            eircode: "D02 KA47",
            city: "New York",
            county: "",
            country: "Ireland",
            postCode: "",
            autoAddressId: "",
            internationalAddress: true,
            addressValidated: false,
            defaultAddress: true,
            filter: "personalAddress",
            displayName: "Home"
        },
        {
            addressLine1: "Apartment 1",
            addressLine2: "4 Leeson Park Street Lower",
            addressLine3: "Dublin 2",
            addressLine4: "",
            addressLine5: "",
            addressLine6: "",
            addressLine7: "",
            addressLine8: "",
            eircode: "D02 KA47",
            city: "New York",
            county: "",
            country: "Ireland",
            postCode: "",
            autoAddressId: "",
            internationalAddress: true,
            addressValidated: false,
            defaultAddress: false,
            filter: "personalAddress",
            displayName: "Business"
        },
        {
            addressLine1: "Apartment 1",
            addressLine2: "4 Leeson Park Street Lower",
            addressLine3: "Dublin 2",
            addressLine4: "",
            addressLine5: "",
            addressLine6: "",
            addressLine7: "",
            addressLine8: "",
            eircode: "D02 KA47",
            city: "New York",
            county: "",
            country: "Ireland",
            postCode: "",
            autoAddressId: "",
            internationalAddress: true,
            addressValidated: false,
            defaultAddress: false,
            filter: "personalAddress",
            displayName: "test"
        },
        {
            addressLine1: "Apartment 1",
            addressLine2: "4 Leeson Park Street Lower",
            addressLine3: "Dublin 2",
            addressLine4: "",
            addressLine5: "",
            addressLine6: "",
            addressLine7: "",
            addressLine8: "",
            eircode: "D02 KA47",
            city: "New York",
            county: "",
            country: "Ireland",
            postCode: "",
            autoAddressId: "",
            internationalAddress: true,
            addressValidated: false,
            defaultAddress: false,
            filter: "personalAddress",
            displayName: "test"
        },
        {
            addressLine1: "Apartment 1",
            addressLine2: "4 Leeson Park Street Lower",
            addressLine3: "Dublin 2",
            addressLine4: "",
            addressLine5: "",
            addressLine6: "",
            addressLine7: "",
            addressLine8: "",
            eircode: "D02 KA47",
            city: "New York",
            county: "",
            country: "Ireland",
            postCode: "",
            autoAddressId: "",
            internationalAddress: true,
            addressValidated: false,
            defaultAddress: false,
            filter: "personalAddress",
            displayName: "test"
        },
        {
            receiverId: "97c055e4-c005-4feb-5ec0-08d743578c48",
            receiver: {
                firstName: "Tony",
                lastName: "Malone",
                companyName: "",
                contactNumber: "",
                emailAddress: "tony.malone@test.email"
            },
            receiverAddress: {
                addressLine1: "Address Line 1",
                addressLine2: " Address Line 2",
                addressLine3: " Address Line 3",
                addressLine4: "",
                addressLine5: "",
                addressLine6: "",
                addressLine7: "",
                addressLine8: "",
                eircode: "",
                city: "Dublin",
                county: "Dublin",
                country: "Ireland",
                postCode: "",
                autoAddressId: "",
                internationalAddress: false,
                addressValidated: false
            },
            filter: "contactAddresses"
        },
        {
            receiverId: "97c055e4-c005-4feb-5ec0-08d743578c52",
            receiver: {
                firstName: "Mark",
                lastName: "Brady",
                companyName: "",
                contactNumber: "",
                emailAddress: "tony.malone@test.email"
            },
            receiverAddress: {
                addressLine1: "Address Line 1",
                addressLine2: " Address Line 2",
                addressLine3: " Address Line 3",
                addressLine4: "",
                addressLine5: "",
                addressLine6: "",
                addressLine7: "",
                addressLine8: "",
                eircode: "",
                city: "New York",
                county: "",
                country: "USA",
                postCode: "",
                autoAddressId: "",
                internationalAddress: true,
                addressValidated: false
            },
            filter: "contactAddresses"
        },
        {
            receiverId: "97c055e4-c005-4feb-5ec0-08d743578c48",
            receiver: {
                firstName: "Tony",
                lastName: "Malone",
                companyName: "",
                contactNumber: "",
                emailAddress: "tony.malone@test.email"
            },
            receiverAddress: {
                addressLine1: "Address Line 1",
                addressLine2: " Address Line 2",
                addressLine3: " Address Line 3",
                addressLine4: "",
                addressLine5: "",
                addressLine6: "",
                addressLine7: "",
                addressLine8: "",
                eircode: "",
                city: "Dublin",
                county: "Dublin",
                country: "Ireland",
                postCode: "",
                autoAddressId: "",
                internationalAddress: false,
                addressValidated: false
            },
            filter: "contactAddresses"
        },
        {
            receiverId: "97c055e4-c005-4feb-5ec0-08d743578c48",
            receiver: {
                firstName: "Tony",
                lastName: "Malone",
                companyName: "",
                contactNumber: "",
                emailAddress: "tony.malone@test.email"
            },
            receiverAddress: {
                addressLine1: "Address Line 1",
                addressLine2: " Address Line 2",
                addressLine3: " Address Line 3",
                addressLine4: "",
                addressLine5: "",
                addressLine6: "",
                addressLine7: "",
                addressLine8: "",
                eircode: "",
                city: "Dublin",
                county: "Dublin",
                country: "Ireland",
                postCode: "",
                autoAddressId: "",
                internationalAddress: false,
                addressValidated: false
            },
            filter: "contactAddresses"
        },
        {
            receiverId: "97c055e4-c005-4feb-5ec0-08d743578c48",
            receiver: {
                firstName: "Tony",
                lastName: "Malone",
                companyName: "",
                contactNumber: "",
                emailAddress: "tony.malone@test.email"
            },
            receiverAddress: {
                addressLine1: "Address Line 1",
                addressLine2: " Address Line 2",
                addressLine3: " Address Line 3",
                addressLine4: "",
                addressLine5: "",
                addressLine6: "",
                addressLine7: "",
                addressLine8: "",
                eircode: "",
                city: "Dublin",
                county: "Dublin",
                country: "Ireland",
                postCode: "",
                autoAddressId: "",
                internationalAddress: false,
                addressValidated: false
            },
            filter: "contactAddresses"
        },
        {
            receiverId: "97c055e4-c005-4feb-5ec0-08d743578c48",
            receiver: {
                firstName: "Tony",
                lastName: "Malone",
                companyName: "",
                contactNumber: "",
                emailAddress: "tony.malone@test.email"
            },
            receiverAddress: {
                addressLine1: "Address Line 1",
                addressLine2: " Address Line 2",
                addressLine3: " Address Line 3",
                addressLine4: "",
                addressLine5: "",
                addressLine6: "",
                addressLine7: "",
                addressLine8: "",
                eircode: "",
                city: "Dublin",
                county: "Dublin",
                country: "Ireland",
                postCode: "",
                autoAddressId: "",
                internationalAddress: false,
                addressValidated: false
            },
            filter: "contactAddresses"
        }
    ],
    success: true,
    errors: []
};

const AddressesFiltersConfig = {
    filters: [
        {
            id: "all",
            label: "All addresses"
        },
        {
            id: "personalAddresses",
            label: "Profile addresses"
        },
        {
            id: "contactAddresses",
            label: "Contacts"
        }
    ]
};

export { AddressesConfig, AddressesFiltersConfig };
